/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stepper, Step, StepLabel, makeStyles, Chip, Tooltip } from "@material-ui/core";
import { FC, ReactNode, useEffect, useState } from "react";
import { AiFillBank, AiFillFile, AiOutlineBarcode, AiOutlineQrcode } from "react-icons/ai";
import { FaCheck, FaExclamationTriangle, FaFileAlt, FaRegCreditCard, FaShoppingBasket, FaTruck } from "react-icons/fa";
import { BOLETO_CARTAO, BOLETO_CARTAO_ID, BOLETO_FINANCIAMENTO, BOLETO_FINANCIAMENTO_ID, BOLETO_FINANCIAMENTO_INDIRETO, BOLETO_FINANCIAMENTO_INDIRETO_ID, BOLETO_ID, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID, CARTAO_CREDITO_ID, CARTAO_FINANCIAMENTO, CARTAO_FINANCIAMENTO_ID, ETAPAS_PAGAMENTO, FINAME, FINAME_ID, FINANCIAMENTO, FINANCIAMENTO_ID, FINANCIMENTO_INDIRETO, FINANCIMENTO_INDIRETO_ID, PIX_CARTAO_CREDITO_ID, PIX_FINANCIAMENTO, PIX_FINANCIAMENTO_ID, PIX_FINANCIAMENTO_INDIRETO, PIX_FINANCIAMENTO_INDIRETO_ID, PIX_ID, situacaoAssinatura, situacaoCarta, situacaoComprovante, situacaoDocumento, situacaoPlano, situacaoProposta } from "src/constants";
import clsx from 'clsx';
import theme from "src/theme/light";
import { FinanceiraType, PedidoType } from "src/types";
import { Formater, LocalStorage, TypeRecords, UrlUtil } from "src/framework/commons";
import { BaixarBoleto } from "../../negociacao/BaixarBoleto";
import { CacheType, cartoesBandeiras$ } from "src/store/global.store";
import "./styles.scss"
import { parseCEP } from "src/framework/commons/masks";
import { FINAMESolo } from "../../TiposPagamento/FINAMESolo";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";

interface EtapasPagamentoProperties {
    pedido: PedidoType;
}


const TEXTO_BOLETO = "Boleto";
const TEXTO_CARTAO_CREDITO = "Cartão de Crédito";
const TEXTO_CARTA_CREDITO = "Financiamento Externo";
const TEXTO_PIX = "Pix";
const TEXTO_FINANCIAMENTO = "Financiamento Via Plataforma";
const TEXTO_FINAME = "FINAME";

const ETAPAS_DEFAULT = {
    [BOLETO_ID]: [TEXTO_BOLETO],
    [CARTAO_CREDITO_ID]: [TEXTO_CARTAO_CREDITO],
    [FINANCIAMENTO_ID]: [TEXTO_FINANCIAMENTO],
    [FINAME_ID]: [TEXTO_FINAME],
    [BOLETO_CARTAO_ID]: [TEXTO_CARTAO_CREDITO, TEXTO_BOLETO],
    [BOLETO_FINANCIAMENTO_ID]: [TEXTO_FINANCIAMENTO, TEXTO_BOLETO],
    [CARTAO_FINANCIAMENTO_ID]: [TEXTO_FINANCIAMENTO, TEXTO_CARTAO_CREDITO],
    [PIX_ID]: [TEXTO_PIX],
    [PIX_CARTAO_CREDITO_ID]: [TEXTO_PIX, TEXTO_CARTAO_CREDITO],
    [PIX_FINANCIAMENTO_ID]: [TEXTO_FINANCIAMENTO, TEXTO_PIX],
    [FINANCIMENTO_INDIRETO_ID]: [TEXTO_CARTA_CREDITO],
    [BOLETO_FINANCIAMENTO_INDIRETO_ID]: [TEXTO_CARTA_CREDITO, TEXTO_BOLETO],
    [CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID]: [TEXTO_CARTA_CREDITO, TEXTO_CARTAO_CREDITO],
    [PIX_FINANCIAMENTO_INDIRETO_ID]: [TEXTO_CARTA_CREDITO, TEXTO_PIX],
}


function getSteps(forma_pagamento_id: number | null, entregue: boolean) {
    if (forma_pagamento_id) {
        return ['Pedido', ...ETAPAS_DEFAULT[forma_pagamento_id], "Nota fiscal", entregue ? "Entregue" : "Transporte"];
    }
    return [];
}


const colorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        color: theme.palette.primary.main + " !important",
        border: "3px solid " + theme.palette.primary.main + " !important",
    },
    completed: {
        backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    },
    "icon-container": {
        borderRadius: "50%",
        border: "3px solid " + theme.palette.grey[500],
        width: "28px",
        height: "28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.grey[500],
    }

});

const WIDTH_QUEBRA = 350;

const EtapasPagamento: FC<EtapasPagamentoProperties> = ({
    pedido
}) => {
    const classes = colorlibStepIconStyles();
    const [etapaAtiva, setEtapaAtiva] = useState(1);
    const [openBaixarBoleto, setOpenBaixarBoleto] = useState<boolean>(false);
    const uploadInfo = LocalStorage.get("solar.uploadInfo", true);
    const [widthScreen, setWidthScreen] = useState<number>(window.innerWidth);
    const [orientacao, setOrientacao] = useState<"vertical" | "horizontal">("horizontal");


    const [alternativeLabel, setAlternativeLabel] = useState<boolean>(true);
    const ETAPAS = getSteps(Number(pedido?.forma_pagamento_id), pedido?.entregue || false);

    const statusComprovante = (situacao: string) => {
        if (pedido.etapa_pagamento === ETAPAS_PAGAMENTO["complemento_pagamento"].value) {
            return "Aguardando Complemento de Pagamento"
        }

        return situacaoComprovante.find((e) => e.value === situacao)?.text;
    }

    const corStatus = (situacao: string) => {
        switch (situacao) {
            case "aprovado":
                return theme.palette.secondary.main;
            case "preenchido":
                return theme.palette.warning.main;
            case "revisao":
                return theme.palette.error.main;
            default:
                return "";
        }
    }

    const corStatusFonte = (situacao: string) => {
        switch (situacao) {
            case "aprovado":
                return theme.palette.secondary.contrastText;
            case "preenchido":
                return theme.palette.warning.contrastText;
            case "revisao":
                return theme.palette.error.contrastText;
            default:
                return "";
        }
    }

    const parseTipoDocumento = (tipo: string): string => {
        let _tipo: string = ""
        if (tipo === "proposta") {
            _tipo = "Proposta"
        }

        if (tipo === "nota_fiscal") {
            _tipo = "Nota Físcal"
        }

        return `Baixar ${_tipo}`;
    }

    const etapaCompleta = (index: number): boolean => {
        if (index === 0 && pedido?.etapa_pagamento && ["dados_clientes", "formas_pagamento", "negociacao", "faturamento"].includes(pedido?.etapa_pagamento)) {
            return true;
        }

        // validar formas de pagamento e se já foi finalizado o pagamento
        if (index === 1 || (ETAPAS.length === 5 && index === 2)) {
            if ([CARTAO_CREDITO_ID, PIX_CARTAO_CREDITO_ID].includes(Number(pedido.forma_pagamento_id))) {
                const cartao: any = [...pedido?.pagamentos?.cartoes_credito || []]?.shift();
                if (cartao?.situacao === "capturado") {
                    return true
                }
            }

            if (pedido.forma_pagamento_id === PIX_ID) {
                const pix: any = [...pedido?.pagamentos?.pix || []]?.shift();
                if (pix?.situacao === "pago") {
                    return true;
                }
            }


            if ([BOLETO_ID, BOLETO_CARTAO.id, BOLETO_FINANCIAMENTO_INDIRETO.id, BOLETO_FINANCIAMENTO.id].includes(Number(pedido.forma_pagamento_id))) {
                const boleto: any = [...pedido?.pagamentos?.boletos || []]?.shift();

                if (boleto?.situacao === "pago") {
                    return true;
                }
            }

            if ([FINANCIMENTO_INDIRETO.id, FINAME.id, BOLETO_FINANCIAMENTO_INDIRETO.id, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO.id, PIX_FINANCIAMENTO_INDIRETO.id].includes(Number(pedido.forma_pagamento_id))) {
                const carta: any = [...pedido?.pagamentos?.cartas_credito || []]?.shift();

                if (carta?.situacao === 'pago') {
                    return true
                }

            }

            if ([FINANCIAMENTO.id, BOLETO_FINANCIAMENTO.id, CARTAO_FINANCIAMENTO.id, PIX_FINANCIAMENTO.id].includes(Number(pedido.forma_pagamento_id))) {
                const financiamento: any = [...pedido?.pagamentos?.financiamentos || []]?.shift();

                if (financiamento?.situacao === 'pago') {
                    return true
                }

            }
        }

        if (pedido.situacao === "finalizado" && ((ETAPAS.length === 4 && index === 2) || (ETAPAS.length === 5 && index === 3))) {
            const _notas = pedido?.documentos?.filter((_doc) => _doc.tipo === "nota_fiscal");
            if (_notas.length) {
                return true;
            }
        }

        if (pedido.situacao === "finalizado" && ((ETAPAS.length === 4 && index === 3) || (ETAPAS.length === 5 && index === 4))) {
            const _notas = pedido?.documentos?.filter((_doc) => _doc.tipo === "nota_fiscal");
            if (pedido?.rastreamentos?.length && _notas.length) {
                return true;
            }
        }

        return false;
    }

    const stepIcon = (indexEtapa: number, forma_pagamento_id: number, activeStep: boolean, entregue: boolean) => {
        const params: any = {
            icon: null
        }

        /** Pedido */
        if (indexEtapa === 0) {
            params.icon = <FaShoppingBasket />
        }


        if (indexEtapa === 1) {

            /**  Financiamento + mesclagem */
            if ([FINANCIAMENTO_ID, FINAME_ID, BOLETO_FINANCIAMENTO_ID, CARTAO_FINANCIAMENTO_ID, PIX_FINANCIAMENTO_ID].includes(forma_pagamento_id)) {
                params.icon = <AiFillBank />
            }

            /** Financiamento indireto + mesclagem */
            if ([FINANCIMENTO_INDIRETO_ID, BOLETO_FINANCIAMENTO_INDIRETO_ID, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID, PIX_FINANCIAMENTO_INDIRETO_ID].includes(forma_pagamento_id)) {
                params.icon = <FaFileAlt />
            }
            
            /** Cartao de Credito e Mesclagens */
            if ([CARTAO_CREDITO_ID, BOLETO_CARTAO_ID].includes(forma_pagamento_id)) {
                params.icon = <FaRegCreditCard />
            }

            /** Boleto */
            if ([BOLETO_ID].includes(forma_pagamento_id)) {
                params.icon = <AiOutlineBarcode />
            }

            /** Pix */
            if ([PIX_ID, PIX_CARTAO_CREDITO_ID].includes(forma_pagamento_id)) {
                params.icon = <AiOutlineQrcode />
            }
        }

        if (ETAPAS.length === 5 && indexEtapa === 2) {

            /** Mesclagem + boleto */
            if ([BOLETO_CARTAO_ID, BOLETO_FINANCIAMENTO_ID, BOLETO_FINANCIAMENTO_INDIRETO_ID].includes(forma_pagamento_id)) {
                params.icon = <AiOutlineBarcode />
            }

            /** Mesclagem + Cartão de crédito */
            if ([CARTAO_FINANCIAMENTO_ID, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID, PIX_CARTAO_CREDITO_ID].includes(forma_pagamento_id)) {
                params.icon = <FaRegCreditCard />
            }

            if ([PIX_FINANCIAMENTO_ID, PIX_FINANCIAMENTO_INDIRETO_ID].includes(forma_pagamento_id)) {
                params.icon = <AiOutlineQrcode />
            }

        }

        /** Nota fiscal */
        if ((ETAPAS.length === 4 && indexEtapa === 2) || (ETAPAS.length === 5 && indexEtapa === 3)) {
            params.icon = <AiFillFile />
        }

        /** Em trânsito e Finalizado */
        if ((ETAPAS.length === 4 && indexEtapa === 3) || (ETAPAS.length === 5 && indexEtapa === 4)) {
            if (entregue) {
                params.icon = <FaCheck />
            } else {
                params.icon = <FaTruck />
            }
        }

        return (<div className={clsx(classes["icon-container"], {
            [classes.active]: activeStep
        })}>{params.icon}</div>);
    }

    const renderStepContent = (index: number): ReactNode => {
        const content: any[] = [];

        /** Pedido */
        if (index === 0) {
            content.push(<div className="item">Pedido registrado em: {Formater.toString(pedido.created_at, TypeRecords.DATE)}</div>)
            if (pedido.endereco_entrega) {
                const endereco = pedido.endereco_entrega;
                content.push(<div className="item"> Entrega: <strong>{endereco?.logradouro}, {endereco?.numero}</strong> <br /> {endereco?.cidade}, {endereco.estado} - {parseCEP(endereco.cep)}</div>)
            }
        }

        /** Pix + mesclagem */
        if ((index === 1 && [PIX_ID, PIX_CARTAO_CREDITO_ID].includes(Number(pedido?.forma_pagamento_id)))
            || (index === 2 && [PIX_FINANCIAMENTO_ID, PIX_FINANCIAMENTO_INDIRETO_ID].includes(Number(pedido?.forma_pagamento_id)))) {
            pedido.pagamentos?.pix?.forEach(_pix => {
                content.push(<div className="item"><strong>Valor pix:</strong> {Formater.toString(_pix.valor_original, TypeRecords.CURRENCY)}</div>)
                if (_pix.situacao === "pago") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="secondary" label="Pago" /></div>)
                    content.push(<div className="item">Pago em: {Formater.toString(_pix.data_pagamento, TypeRecords.DATE)}</div>)
                }

                if (_pix.situacao === "pendente") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="default" label="Pendente" /></div>)
                }
            })
        }

        /** Boleto e mesclagens */
        if ((index === 1 && [BOLETO_ID].includes(Number(pedido?.forma_pagamento_id)))
            || (index === 2 && [BOLETO_FINANCIAMENTO_ID, BOLETO_FINANCIAMENTO_INDIRETO_ID, BOLETO_CARTAO_ID].includes(Number(pedido?.forma_pagamento_id)))) {
            pedido.pagamentos?.boletos?.forEach((b) => {
                content.push(<div className="item"><strong>Valor boleto:</strong> {Formater.toString(b.valor_original, TypeRecords.CURRENCY)}</div>)
                if (b.situacao === "pago") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="secondary" label="Pago" /></div>)
                    content.push(<div className="item">Pago em: {Formater.toString(b.data_pagamento, TypeRecords.DATE)}</div>)
                }

                if (b.situacao === "gerado") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="secondary" label="Pagamento não concluído" /></div>)
                    content.push(<div className="item">Vencimento: {Formater.toString(b.data_vencimento, TypeRecords.DATE)}</div>)
                    content.push(<div className="item"><a href="javascript:" style={{ color: theme.palette.primary.main, textDecoration: "none" }} onClick={() => setOpenBaixarBoleto(true)}>Clique aqui para visualizar o boleto</a></div>)
                }

            })
        }

        /** Cartão de crédido + mesclagens */
        if ((index === 1 && [CARTAO_CREDITO_ID, BOLETO_CARTAO_ID].includes(Number(pedido?.forma_pagamento_id)))
            || (index === 2 && [CARTAO_FINANCIAMENTO_ID, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID, PIX_CARTAO_CREDITO_ID].includes(Number(pedido?.forma_pagamento_id)))) {
            const cartoesBandeiras = cartoesBandeiras$.getValue();

            pedido.pagamentos?.cartoes_credito?.forEach((c) => {
                const cartaoBandeira: any = cartoesBandeiras?.data?.find((cb: any) => cb.id === c.cartao_bandeira_id);
                content.push(<div className="item"><strong>Valor no crédito:</strong> {Formater.toString(c.valor_original, TypeRecords.CURRENCY)}</div>)
                content.push(<div className="item">Cartão <strong>{cartaoBandeira?.nome}</strong> com final <strong>{c.numero}</strong></div>)
                content.push(<div className="item">{c?.parcelas}x {Formater.toString(Number((c.valor/c?.parcelas).toFixed(2)), TypeRecords.CURRENCY)}</div>)

                if (c.situacao === "capturado") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="secondary" label="Pago" /></div>)
                    content.push(<div className="item">Pago em: {Formater.toString(c.data_pagamento, TypeRecords.DATE)}</div>)
                }

                if (c.situacao === "autorizado") {
                    content.push(<div className="item"><Chip variant="default" size="small" color="default" label="Aguardando autorização" /></div>)
                }

            })
        }

        /** Financiamento */
        if ((index === 1 && [FINANCIAMENTO.id, BOLETO_FINANCIAMENTO.id, CARTAO_FINANCIAMENTO.id, PIX_FINANCIAMENTO.id].includes(Number(pedido.forma_pagamento_id)))) {
            const financeiras = LocalStorage.get<CacheType<FinanceiraType[]>>("solar.financeiras", true);

            pedido.pagamentos?.financiamentos?.forEach((f: any) => {
                const financeira = financeiras?.data?.find((_f) => _f.id === f.financeira_id)
                // const banco:any = bancos?.data?.find((b) => b.) 
                content.push(<div className="item"><strong>Valor financiado:</strong> {Formater.toString(f.valor_original, TypeRecords.CURRENCY)} em <strong>{f.parcelas}x</strong></div>)

                // financeira
                if (financeira) {
                    content.push(<div className="item"><strong>Financeira:</strong> {financeira.nome}</div>)
                }

                // situação da proposta
                content.push(
                    <div className="item" >
                        <Chip
                            variant="default"
                            size={widthScreen <= WIDTH_QUEBRA ? "medium" : "small"}
                            color={f.situacao_proposta === "aprovado" ? "secondary" : "default"}
                            style={widthScreen <= WIDTH_QUEBRA ? {paddingTop: "21px", paddingBottom: "21px", borderRadius: "20px"} : {}}
                            label={
                                <div className="chip">
                                    <div style={{marginRight: f.situacao_proposta !== "aprovado" ? "3px" : "0"}}>
                                        {f.situacao_proposta !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />}
                                    </div>
                                    <div className="chip-item">
                                        {`Situação proposta: `} {widthScreen <= WIDTH_QUEBRA && <br />} {`${situacaoProposta.find((e) => e.value === f.situacao_proposta)?.text || "-"}`}
                                    </div>
                                </div>
                            }
                        />
                    </div>);

                content.push(
                    <div className="item">
                        <Chip
                            variant="default"
                            size={widthScreen <= WIDTH_QUEBRA ? "medium" : "small"}
                            color={f.situacao_proposta_plano === "enviado" ? "secondary" : "default"}
                            style={widthScreen <= WIDTH_QUEBRA ? {paddingTop: "21px", paddingBottom: "21px", borderRadius: "20px"} : {}}
                            label={
                                <div className="chip">
                                    <div style={{marginRight: f.situacao_proposta_plano !== "enviado" ? "3px" : "0"}}>
                                        {f.situacao_proposta_plano !== "enviado" && <FaExclamationTriangle color={theme.palette.warning.main} />}
                                    </div>
                                    <div className="chip-item">
                                        {`Situação Plano:`} {widthScreen <= WIDTH_QUEBRA && <br />} {`${situacaoPlano.find((e) => e.value === f.situacao_proposta_plano)?.text || "-"}`} 
                                    </div>
                                </div>
                            }
                            
                        />
                    </div>);

                // Situação do documentos
                content.push(
                    <div className="item">
                        <Chip variant="default"
                            size={widthScreen <= WIDTH_QUEBRA ? "medium" : "small"}
                            color={f.situacao_documentos === "aprovado" ? "secondary" : "default"}
                            style={widthScreen <= WIDTH_QUEBRA ? {paddingTop: "21px", paddingBottom: "21px", borderRadius: "20px"} : {}}
                            label={<div className="chip"> <div style={{marginRight: f.situacao_documentos !== "aprovado" ? "3px" : "0"}}>{f.situacao_documentos !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />} </div>
                               <div className="chip-item"> {`Situação documentos: `} {widthScreen <= WIDTH_QUEBRA && <br />} {`${situacaoDocumento.find((e) => e.value === f.situacao_documentos)?.text || "-"}`}</div></div>}
                        />
                    </div>);

                // situação do assinatura
                content.push(
                    <div className="item">
                        <Chip
                            variant="default"
                            size={widthScreen <= WIDTH_QUEBRA ? "medium" : "small"}
                            style={widthScreen <= WIDTH_QUEBRA ? {paddingTop: "21px", paddingBottom: "21px", borderRadius: "20px"} : {}}
                            color={f.situacao_assinatura === "aprovado" ? "secondary" : "default"}
                            label={<div className="chip"> <div style={{marginRight: f.situacao_assinatura !== "aprovado" ? "3px" : "0"}}>{f.situacao_assinatura !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />} </div>
                               <div className="chip-item"> {`Situação Assinatura: `} {widthScreen <= WIDTH_QUEBRA && <br />} {`${situacaoAssinatura.find((e) => e.value === f.situacao_assinatura)?.text || "-"}`}</div></div>}
                        />
                    </div>);

                // url do financiamento
                const _proposta_financiamento = pedido?.documentos?.filter((_doc) => _doc.tipo === "proposta_financiamento");
                if (_proposta_financiamento.length && _proposta_financiamento[0].url) {
                    content.push(
                        <div className="item">
                            Clique <a href="javascript:" style={{ color: theme.palette.primary.main, textDecoration: "none" }} onClick={() => UrlUtil.goto(`//${uploadInfo?.data?.url}${_proposta_financiamento[0].url}`, true)}><strong>aqui</strong></a> fazer o download da proposta da financeira
                        </div>
                    );
                }
            })
        }

        /** Financiamento indireto */
        if ((index === 1 && [FINANCIMENTO_INDIRETO.id, FINAME.id, BOLETO_FINANCIAMENTO_INDIRETO.id, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO.id, PIX_FINANCIAMENTO_INDIRETO.id].includes(Number(pedido.forma_pagamento_id)))) {
            pedido?.pagamentos?.cartas_credito?.forEach((cc: any) => {
                // const banco:any = bancos?.data?.find((b) => b.) 
                content.push(<div className="item"><strong>Valor financiado:</strong> {Formater.toString(cc.valor_original, TypeRecords.CURRENCY)}</div>)
                // banco
                content.push(<div className="item"><strong>Banco:</strong> {cc.banco}</div>)
                // situação da carta de credito
                //content.push(<div className="item" ><Chip variant="default" size="small" color={cc.situacao_carta === "aprovado" ? "secondary" : "default"} label={<> {cc.situacao_carta !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />} {`Carta de Credito está: ${situacaoCarta.find((e) => e.value === cc.situacao_carta)?.text || "-"}`}</>} /></div>)
                content.push(<div className="item"><Chip variant="default" size={widthScreen <= 950 ? "medium" : "small"} color={cc.situacao_carta === "aprovado" ? "secondary" : "default"} style={{paddingTop: widthScreen <= 950 ? "21px" : 2, paddingBottom: widthScreen <= 950 ? "21px" : 2, borderRadius: widthScreen <= 950 ? "20px" : 16 }} label={<> <div className="chip"> <div style={{marginRight: cc.situacao_carta !== "aprovado" ? "3px" : "0"}}>{cc.situacao_carta !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />}</div> <div className="chip-item"> {`Carta de Credito está: `} {widthScreen <= 950 && <><br /></>} {`${situacaoCarta.find((e) => e.value === cc.situacao_carta)?.text|| "-"}`} </div></div></>} /></div>)
                // situação do comprovante
                content.push(<div className="item"><Chip variant="default" size={widthScreen <= 950 ? "medium" : "small"} style={{ backgroundColor: corStatus(cc.situacao_comprovante || ""), color: corStatusFonte(cc.situacao_comprovante || "", ), paddingTop: widthScreen <= 950 ? "21px" : 2, paddingBottom: widthScreen <= 950 ? "21px" : 2, borderRadius: widthScreen <= 950 ? "20px" : 16 }} label={<> <div className="chip"> <div style={{marginRight: cc.situacao_comprovante !== "aprovado" ? "3px" : "0"}}>{cc.situacao_comprovante !== "aprovado" && <FaExclamationTriangle color={theme.palette.warning.main} />}</div> <div className="chip-item"> {`Comprovante de Pagamento está:`} {widthScreen <= 950 && <><br /></>} {`${statusComprovante(cc.situacao_comprovante) || "-"}`} </div></div></>} /></div>)
            })
        }

        /** Nota fiscal */
        if ((ETAPAS.length === 4 && index === 2) || (ETAPAS.length === 5 && index === 3)) {
            const _notas = pedido?.documentos?.filter((_doc) => _doc.tipo === "nota_fiscal");
            if (pedido?.documentos?.length) {
                if (!_notas[0]) {
                    content.push(<div className="item">
                        O Pedido ainda não está faturado.
                    </div>)
                }

                for (const doc of _notas || []) {
                    if (doc.url) {
                        content.push(<div className="item">
                            Nota fiscal nº <Tooltip title={parseTipoDocumento(doc.tipo)}><a href="javascript:" onClick={async () => {
                                if (pedido?.codigo_venda) {
                                    const pedidosProvider = new PedidosProvider();
                                    const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                                    if (responsePedido.statusCode !== STATUS_CODE.OK) return;
                                }
                                UrlUtil.goto(`//${uploadInfo?.data?.url}${doc.url}`, true);
                            }}>{doc?.numero}</a></Tooltip>. {widthScreen <= WIDTH_QUEBRA && <br />} {doc?.data_emissao && <>Emitido em {Formater.toString(doc.data_emissao, TypeRecords.DATE)}</>}
                        </div>)
                    } else {
                        content.push(<div className="item">
                            Nota fiscal nº <strong>{doc?.numero}</strong>. {widthScreen <= WIDTH_QUEBRA && <br />} {doc?.data_emissao && <>Emitido em {Formater.toString(doc.data_emissao, TypeRecords.DATE)}</>}
                        </div>)
                    }
                }
            } else {
                content.push(<div className="item">
                    O Pedido ainda não está faturado.
                </div>)
            }
        }

        /** Em trânsito e Finalizado */
        if (((ETAPAS.length === 4 && index === 3) || (ETAPAS.length === 5 && index === 4))) {
            if (pedido?.rastreamentos?.length) {
                for (const rastreamento of pedido?.rastreamentos || []) {
                    if (!rastreamento.status_finalizador) {
                        content.push(<div className="item">
                            Situação de <strong>{rastreamento.ocorrencia}</strong> em <strong>{Formater.toString(rastreamento.data_rastreamento, TypeRecords.DATE)}</strong>.<br />
                            {rastreamento.observacao || "Nenhum detalhe informado"}<br />
                            Clique <Tooltip title="Link Rastreamento"><a href="javascript:" onClick={() => {
                                UrlUtil.goto(rastreamento.link_rastreio, true);
                            }}>aqui</a></Tooltip> para rastrear seu pedido.
                        </div>)
                    } else {
                        content.push(<div className="item">
                            Seu pedido foi entregue em <strong>{Formater.toString(rastreamento.data_rastreamento, TypeRecords.DATE)}</strong>.<br />
                            Clique <Tooltip title="Link Rastreamento"><a href="javascript:" onClick={() => {
                                UrlUtil.goto(rastreamento.link_rastreio, true);
                            }}>aqui</a></Tooltip> para rastrear seu pedido.
                        </div>)
                    }
                }
            } else {
                content.push(<div className="item">
                    O Pedido ainda não está com a transportadora.
                </div>)
            }
        }

        return <div className="step-content">
            {content.map((c, idx) => {
                return <div key={`${pedido.codigo_venda}-${index}-${idx}`} className={`${pedido.codigo_venda}-${index}-${idx}`}>{c}</div>;
            })}
        </div>
    }

    const renderStep = (label: string, index: number): ReactNode => {

        return (<Step key={`step-${pedido.codigo_venda}-${label}-${index}`}>
            <StepLabel icon={stepIcon(index, Number(pedido?.forma_pagamento_id), etapaCompleta(index), pedido?.entregue || false)}>{label}</StepLabel>
            {renderStepContent(index)}
        </Step>)

    }

    useEffect(() => {
        window.addEventListener('resize', () => {
            const { innerWidth } = window;
            setOrientacao(innerWidth < theme.breakpoints.values.md ? "vertical" : "horizontal")
            setAlternativeLabel(innerWidth < theme.breakpoints.values.md ? false : true)
            setWidthScreen(window.innerWidth);
        });
    }, []);

    return <div className="EtapasPagamento">

        {ETAPAS.length ?
            <>
                {widthScreen <= 950 ? <>
                    {ETAPAS.map((label, index) => (
                        <>
                            <div className="step">
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    {stepIcon(index, Number(pedido?.forma_pagamento_id), etapaCompleta(index), pedido?.entregue || false)}
                                    <div>
                                        {label}
                                    </div>
                                    <div>
                                        {renderStepContent(index)}
                                    </div>
                                    { (ETAPAS.length - 1) > index ? <div className="step-separador"/> : ""}
                                </div>
                            </div>
                        </>
                    ))}
                </> : <>    
                <Stepper activeStep={etapaAtiva} alternativeLabel={alternativeLabel} orientation={orientacao}>
                    {ETAPAS.map((label, index) => (
                        renderStep(label, index)
                    ))}
                </Stepper>
                </>}
            </>
        : ""}
        <BaixarBoleto
            open={openBaixarBoleto}
            onClose={() => {
                setOpenBaixarBoleto(false)
            }}
            onConfirm={() => {
                setOpenBaixarBoleto(false)
            }}
            pagamentoId={pedido?.pagamento_id}
        />
    </div>
}

export { EtapasPagamento }